import { render, staticRenderFns } from "./EditObject.vue?vue&type=template&id=078f4f0b&scoped=true&"
import script from "./EditObject.vue?vue&type=script&lang=js&"
export * from "./EditObject.vue?vue&type=script&lang=js&"
import style0 from "./EditObject.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditObject.vue?vue&type=style&index=1&id=078f4f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078f4f0b",
  null
  
)

export default component.exports